<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-10-22 16:27:04
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-15 21:07:07
-->
<template>
  <div class="rolesclass">
    <div class="contentWrapper disinfectList">
      <div class="rolestop">
        <span class="acclist">{{$t('account.userlist')}}</span>
        <span>
          <el-input
            v-model="searchusername"
            clearable
            :placeholder="$t('account.searchnames')"
            class="inputStyle"
            @change="searchnamesChange"
            @input="searchnamesInput"
          >
            <template #append>
              <!-- <Search size="20" style="width: 1.5em; height: 1.em;" color="#fff" @click="upgradegetaccount" /> -->
              <el-icon
                size="16"
                class="upgradeclass"
                @click="upgradegetaccount"
              >
                <Search color="#fff" />
              </el-icon>
            </template>
          </el-input>
        </span>
        <span class="btnadd" @click="addroles" >
          <el-icon size="16" class="addroles">
            <Plus />
          </el-icon>
          <span>{{$t('account.adduser')}}</span>
        </span>
      </div>
      <el-table :data="tableData" style="width: 100%" @cell-click="rowclicks" header-row-class-name="Headerrowclass">
        <el-table-column prop="name" :label="$t('account.user')" width="180">
          <template #default="{ row }">
            <span :style="{color:'rgb(24, 144, 255)'}">{{ row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="menu" :label="$t('account.roles')">
          <template #default="{ row }">
            <span>{{ row.role_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('account.ResponsibleRobot')">
          <template #default="{ row }">
            <span>{{ getsnlength(row.robot_sn) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('account.name')">
          <template #default="{ row }">
            <span>{{ row.nick_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('account.remark')">
          <template #default="{ row }">
            <span :style="{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}">{{ row.remark?row.remark:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('account.Recentloginiof')" :width="adapter_width()">
          <template #default="{ row }">
            <span>{{ getlogintimes(row.login_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('account.operation')" :width="td_width()">
          <template #default="{ row }">
            <div>
              <span :style="{ color: '#1890FF' }" @click.stop="editroleas(row)"
                >{{$t('account.compile')}}</span
              >
              <span
                :style="{ marginLeft: '32px', color: '#FAAD14'}"
                @click.stop="deleteroleas(row, 1)"
                >{{$t('account.resetpasswords')}}</span
              >
              <span
                :style="{ marginLeft: '32px', color: '#F5222D' }"
                @click.stop="deleteroleas(row, 2)"
                >{{$t('account.delete')}}</span
              >
            </div>
          </template>
        </el-table-column>
        <template #empty>
          <div>
            <!-- <img :src="totalImg.nodata" /> -->
            <p>{{ $t("system.noData") }}</p>
          </div>
        </template>
      </el-table>
      <el-pagination
        :background="true"
        v-show="total > 0"
        :page-size="formInline.pageSize"
        :total="total"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, sizes"
        class="pagination"
      />
    </div>
    <el-dialog
      v-model="dialogVisible"
      v-if="dialogVisible"
      :title="accouttitle"
      width="35%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form :rules="rules" label-width="160px" :model="form" ref="userFormRef">
        <el-form-item :label="`${$t('account.user')}：`" prop="name">
          <el-input
            type="text"
            :disabled="rolenamedisabled"
            :style="{ width: '75%' }"
            v-model="form.name"
            :onkeyup="keyuptextname"
            maxlength="20"
            :placeholder="$t('account.pleaseuserpasnumb')"
            @change="userChange"
          />
        </el-form-item>
        <el-form-item :label="`${$t('login.password')}：`" prop="passwords">
          <el-input
            type="password"
            :style="{ width: '75%' }"
            v-show="!rolenamedisabled"
            v-model="form.passwords"
            :show-password="true"
            :onkeyup="keyuppasswords"
            :placeholder="$t('account.pleaseuserpasnumb')"
            maxlength="20"
            @input="passwordInput"
          />
          <span
            v-show="rolenamedisabled"
            :style="{ color: '#FAAD14' ,'cursor': 'pointer'}"
            @click="deleteroleas({ id: detatildata.id }, 1)"
            >{{$t('account.resetpasswords')}}</span
          >
        </el-form-item>
        <el-form-item :label="`${$t('account.roles')}：`" prop="rolesname">
          <el-select
            v-model="form.rolesname"
            :placeholder="$t('account.selectroles')"
            :style="{ width: '75%' }"
          >
            <el-option
              v-for="(ele, index) in rolelist"
              :label="ele.name"
              :value="ele.ID"
              :key="index"
            />
          </el-select>
          <span :style="{marginLeft:'3%',cursor:'pointer'}" v-if="form.rolesname!=''"> 
    <el-popover

    popper-class="popperOptions"
    placement="top-start"
    :title="$t('route.jurisdiction')"
    trigger="hover"
    :content="getrolesdetail()"
  >
    <template #reference>
      <img src="../../assets/images/home/edition.png" alt="" :style="{width:'20px',verticalAlign:'sub'}">
    </template>
  </el-popover></span>
        </el-form-item>
        <!-- 去掉楼宇绑定 删除这方面的逻辑 -->
        <el-form-item :label="`${$t('account.ResponsibleRobot')}：`" prop="buildname" v-if="false">
          <el-select
            v-model="form.buildname"
            :placeholder="$t('account.Pleasebuilds')"
            multiple
            collapse-tags
            :style="{ width: '75%' }"
            @change="setrobotflge"
          >
            <el-option
              v-for="(ele, index) in buildlist"
              :label="ele.name"
              :value="ele.id"
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('account.ResponsibleRobot')}：`" prop="robotnames">
          <el-select
            v-model="form.robotnames"
            :placeholder="$t('account.PleaseRobots')"
            multiple
            collapse-tags
            :style="{ width: '75%' }"
          >
            <el-option
              v-for="(ele, index) in robotlists"
              :label="ele.nick_name"
              :style="{color:ele.status=='leave'?'#acacac':'#409eff'}"
              :value="ele.sn"
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('account.name')}：`">
          <el-input
            type="text"
            :style="{ width: '75%' }"
            v-model="form.surname"
            :placeholder="$t('account.inputnames')"
            maxlength="20"
            @change="nameChange"
            @input="nameInput"
          />
        </el-form-item>
        <el-form-item :label='`${$t("account.remark")}：`' prop="desc">
          <el-input
            v-model="form.fromdesc"
            type="textarea"
            :style="{ width: '75%' }"
            maxlength="100"
            :placeholder="$t('account.inputremarks')"
            @change="remarkChange"
            @input="remarkInput"
          />
        </el-form-item>
        <!-- <el-form-item :label="'账号：'" prop="name">
            <el-input
              type="text"
              :disabled="rolenamedisabled"
              :style="{ width: '240px' }"
              v-model="form.name"
            />
          </el-form-item>
          <el-form-item :label="'账号：'" prop="name">
            <el-input
              type="text"
              :disabled="rolenamedisabled"
              :style="{ width: '240px' }"
              v-model="form.name"
            />
          </el-form-item> -->
        <!-- <el-form-item label="账号：" prop="name">
          <el-input v-model="form.name" />
         </el-form-item> -->
      </el-form>
      <div class="btndiv">
        <button class="btncancel" @click="cancelmsg">{{$t('universality.cancel')}}</button>
        <button class="btnconfirm" @click="trimbtn">{{$t('universality.confirm')}}</button
        >
      </div>
    </el-dialog>
    <el-drawer v-model="drawerfalge" :title="$t('account.userdetail')">
        <el-scrollbar height="850px">
      <p class="field">
        {{$t("account.user")}}<span class="field-text">{{ drawerdetail.username }}</span>
      </p>
      <p class="field">
        {{$t('account.roles')}}<span class="field-text">{{ drawerdetail.role_name }}</span>
      </p>
      <p class="field">
        {{$t('route.jurisdiction')}}<span class="field-text">{{
          getjurisdiction(drawerdetail.menu_name)
        }}</span>
      </p>
      <p class="field special">
        <span>{{$t('account.ResponsibleRobot')}}</span
        ><span
          ><div class="field-text">
            {{ drawerdetail.robot_count>0?drawerdetail.robot_count+$t('account.platform'):$t('account.noBindingRobot') }}
          </div>
          <!-- <div class="field-text">楼宇名称：</div>
          <div class="field-text">
            机器人备注名、SN、SN、机器人备注名、机器人备注名、机器人备注名
          </div> -->
          <div class="field-text" v-for="(ele,index) in drawerdetail.robot_manage" :key="index">
            {{ele.nick_name?ele.nick_name:ele.sn}}
          </div>
        </span>
      </p>
      <p class="field">
        {{$t('account.name')}}<span class="field-text">{{ drawerdetail.nick_name }}</span>
      </p>
      <p class="field">
        {{$t('account.addtimes')}}<span class="field-text">{{
          getlogintimes(drawerdetail.create_time)
        }}</span>
      </p>
      <p class="field">
        {{$t('account.LastonlineTime')}}<span class="field-text">{{
          getlogintimes(drawerdetail.login_time)
        }}</span>
      </p>
      <div class="fieldremark">
       <div>{{$t('account.remark')}}</div><div class="field-text">{{drawerdetail.remark
        }}</div>
      </div>
        </el-scrollbar>
    </el-drawer>
    <Newdialog
      :dialogVisibles="deletemapflage"
      :detatildata="detatildata"
      :buttonColor="btnColor"
      :borderColor="dialogTtile"
      @setdata="delroles"
      @cancelvisibles="cancelvisibles"
    />
    <el-dialog v-model="successfalge" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div class="text-box">
            <img src="../../assets/images/login/success.png">
            <span class="title-text">{{$t('account.Resetsuccessfully')}}</span>
        </div>
        <div>{{$t('account.initialPassword')}}：12345678</div>
        <div class="dialog-footer">
            <!-- <el-button v-if="btnFlag" @click="cancel">取 消</el-button> -->
            <!-- <el-button type="primary" :style="{background:(dialogVisible?setStyle():setStyle())}" @click="confirm">确 定</el-button> -->
            <el-button type="primary" @click="successfalge=false">{{$t('account.gotIt')}}</el-button>
        </div>
    </el-dialog>
     <el-dialog v-model="ChangeAuthorityflg" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div class="text-box">
            <img src="../../assets/images/login/I.png">
            <span class="title-text">{{$t('account.Changeofauthority')}}</span>
        </div>
        <div :style="{marginLeft:'20px'}">{{$t('robot.accountInformationHasBeenModified')}}</div>
        <div class="dialog-footer">
            <!-- <el-button v-if="btnFlag" @click="cancel">取 消</el-button> -->
            <!-- <el-button type="primary" :style="{background:(dialogVisible?setStyle():setStyle())}" @click="confirm">确 定</el-button> -->
            <el-button type="primary" @click="ChangeAuthorityflg=false">{{$t('universality.confirm')}}</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs,
  unref,
} from "vue";
import { roomInfo } from "@/apis/region";
import { getRobotList } from "@/apis/user";
import { robotsSearch } from "@/apis/robot";
import {
  getroles,
  addaccuser,
  delaccuser,
  getaccuser,
  upgradeaccuser,
  getaccuserdetails,
  replacementpswd
} from "@/apis/roles";
import { buildingListRequest, buildingRobots,buildingRobotsAll,shopQuery } from "@/apis/building";
import { useRouter, useRoute } from "vue-router";
import moment from "moment";
import { ElForm,ElMessage } from "element-plus";
import Newdialog from "@/components/tydialog/Dialog.vue";
import {
  getHM,
  totalImg,
  setRobotName,
  disinfectType,
  valueFilter,
  momentStamp
} from "@/utils/robot";
import { getLanguage } from "@/utils/cookies";
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { inputRules,chineseVerification,inputLengthLimit } from '@/utils/validate'
export default {
  components: { Newdialog },
  setup() {
    const searchForm = ref(ElForm);
    const router = useRouter();
    const route = useRoute();
    const userFormRef = ref(ElForm)
    const reusername = /^[0-9a-zA-Z]*$/g
    const validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_t('login.tip_username')))
      } else if(value.length>20 || value.length<6){
        callback(new Error(_t('account.pleaseuserpasnumb')))
      } 
      // else if(!reusername.test(value)) {
      //   callback('不要输入特殊字符')
      // } 
      else {
        callback()
      }
    };
    const validatepaswords = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_t('login.tip_pwd')))
      } else if(value.length>20 || value.length<6){
        callback(new Error(_t('account.pleaseuserpasnumb')))
      } 
      // else if(!reusername.test(value)) {
      //   callback('不要输入特殊字符')
      // } 
      else {
        callback()
      }
    };
     const validaterolesname = (rule, value, callback) => {
      if (value=='') {
     
        callback(new Error(_t('account.PleaseRoles')))
      }else {
     
        callback()
      }
     };
      const validatebuildname = (rule, value, callback) => {
      // if (value=='') {
        // callback(new Error(_t('account.Pleasebuilds')))
      // }else {
        callback()
      // }
    };
    const validaterobotnames = (rule, value, callback) => {
      // if (value=='') {
      //   callback(new Error(_t('account.PleaseRobots')))
      // }else {
        callback()
      // }
    }
    const state = reactive({
      successfalge:false,
      deletemapflage: false,
      detatildata: { id: "",types:"" },
      btnColor: "#F5222D",
      color: "#ffffff",
      dialogTtile: "",
      searchusername: "",
      form: {
        name: "",
        passwords: "",
        rolesname: "",
        buildname: [],
        robotnames: [],
        fromdesc: "",
        surname: "",
      },
      rolenamedisabled: false,
      buildflge: false,
      rolelist: [],
      buildlist: [],
      accouttitle: "",
      robotlists: [
      ],
      roomData: [],
      rules: {
        name: [
          {
            validator:validateUser,
            trigger: "blur",
            required: true
          },
        ],
        passwords: [
          { validator:validatepaswords, trigger: "blur",required:true },
        ],
        rolesname: [
          {validator:validaterolesname,required: true, },
        ],
        buildname: [
          { validator:validatebuildname,required: true, },
        ],
         robotnames: [
          {validator:validaterobotnames},
        ],
      },
      formInline: {
        pageSize: 10,
        page: 1,
        userName: "",
      },
      drawerfalge: false,
      drawerdetail: "",
      robotflge: true,
      valueroles: [],
      dialogVisible: false,
      totalImg: totalImg(),
      getHM: getHM,
      disinfectType: disinfectType,
      setRobotName: setRobotName,
      total: 0,
      page: 1,
      tableData: [],
      rolenumes:'',
      ChangeAuthorityflg:false,
      language: getLanguage(),
      searchnamesChange(){
        state.searchusername = state.searchusername.trim()
      },
      searchnamesInput(){
        // state.searchusername = inputRules(state.searchusername)
      },
      userChange(){
        state.form.name = state.form.name.trim()
      },
      passwordInput(){
        state.form.passwords = chineseVerification(state.form.passwords) 
      },
      nameChange(){
        state.form.surname = state.form.surname.trim()
      },
      nameInput(){
        // state.form.surname = inputRules(state.form.surname)
        state.form.surname = inputLengthLimit(state.form.surname,20)
      },
      remarkChange(){
        state.form.fromdesc = state.form.fromdesc.trim()
      },
      remarkInput(){
        // state.form.fromdesc = inputRules(state.form.fromdesc)
        state.form.fromdesc = inputLengthLimit(state.form.fromdesc,100)
      },
      adapter_width(){
        if(state.language == 'fr'){
          return 185
        }else if(state.language == 'pl'){
          return 230
        }else {
          return 185
        }
      },
      // 多语言适配
      td_width(){
        if(state.language == 'en'){
          return 300
        }else if(state.language == 'zh-cn'){
          return 300
        }else if(state.language == 'ko'){
          return 300
        }else if(state.language == 'de'){
          return 380
        }else if(state.language == 'fr'){
          return 370
        }else if(state.language == 'ja'){
          return 300 
        }else if(state.language == 'nl'){
          return 420
        }else if(state.language == 'pl'){
          return 300
        }
      },
      popover_width(){
        if(state.language == 'en'){
          return 150 
        }else if(state.language == 'zh-cn'){
          return 150
        }else if(state.language == 'ko'){
          return 150
        }else if(state.language == 'de'){
          return 150
        }else if(state.language == 'fr'){
          return 150
        }else if(state.language == 'ja'){
          return 150 
        }else if(state.language == 'nl'){
          return 200
        }else if(state.language == 'pl'){
          return 150
        }
      },
      // 获取当前语言兼容性问题
      getlagus(){
       return getLanguage()
      },
      getrolesdetail() {
        let msssg = ''
        if (state.form.rolesname) {
          state.rolelist.forEach((ele,index)=>{
            // console.log(ele)
             if (ele.ID == state.form.rolesname) {
              // console.log(state.rolelist[index].menu_name)
               msssg = state.getjurisdiction(state.rolelist[index].menu)
             }
          })
        }
       
        return msssg
      },
      keyuptextname(e) {
        
          state.form.name=e.target.value.replace(/[^\x00-\xff]/gi,'')
      },
      keyuppasswords(e) {
        
          // state.form.name=e.target.value.replace(/[^\x00-\xff]/gi,'')
          if (e.target.type == 'text') {
            state.form.passwords = e.target.value.replace(/[^\x00-\xff]/gi,'')
          }
      },
      getList() {
        const data = state.formInline;
        getaccuser(data).then((res) => {
          if (res.code == 200) {
            state.tableData = res.data.list;
            state.total = res.data.total;
            state.page = state.formInline.page;
            
          }
        });
      },
      setrobotflge(val) {
        // console.log("1112321", state.form.robotnames);
  
        state.form.robotnames = [];
        // state.robotlists = [];
        // buildingRobotsAll({
        //   limit: false,
        //   buildings: val.join(),
        // }).then((res) => {
          
        //   state.robotlists = res.data;
        // });
        state.form.robotnames = "";
        if (val.length > 0) {
          state.robotflge = false;
          state.buildflge = false;
        } else {
          state.robotflge = true;
          state.buildflge = true;
        }
      },
      rowclicks(row, column, cell, event) {
        // 热区变动 从整行生效到某一tell生效
        if (column.property != 'name') {
              return
        }
        getaccuserdetails({username:row.username}).then(res=>{
           
           state.drawerdetail = res.data;
           state.drawerfalge = true;
        })
      },
      getjurisdiction(menu) {
      let rowlist = menu.split(",");
         let msg = ''
         rowlist.map((ele,index)=>{
            if (ele == 'robot') {
                if (index+1==rowlist.length) {
                    msg+=_t('route.robot') + '\n'
                } else {
                    msg+=_t('route.robot')+'/' + '\n'
                }
            } else if (ele == 'building') {
              if (index+1==rowlist.length) {
                    msg+=_t('route.building') + '\n'
                } else {
                    msg+=_t('route.building')+'/' + '\n'
                }
            } else if (ele == 'disinfect') {
              if (index+1==rowlist.length) {
                    msg+=_t('route.disinfectTask') + '\n'
                } else {
                    msg+=_t('route.disinfectTask')+'/' + '\n'
                }
            } else if (ele == 'home') {
               if (index+1==rowlist.length) {
                    msg+=_t('route.home') + '\n'
                } else {
                    msg+=_t('route.home')+'/' + '\n'
                }
            } else if (ele == 'IOT') {
               if (index+1==rowlist.length) {
                    msg+='IOT' + '\n'
                } else {
                    msg+='IOT/' + '\n'
                } 
            } else if (ele == 'jurisdiction') {
              if (index+1==rowlist.length) {
                    msg+=_t('route.jurisdiction') + '\n'
                } else {
                    msg+=_t('route.jurisdiction')+'/' + '\n'
                }
            } else if (ele == 'dispatcher') {
              if (index+1==rowlist.length) {
                    msg+= _t('route.dispatcher') + '\n'
                } else {
                    msg+= _t('route.dispatcher') + '/' + '\n'
                }
            } else if (ele == 'admage') {
                    if (index+1==rowlist.length) {
                    msg+= _t('route.admage') + '\n'
                } else {
                   msg+= _t('route.admage') + '/' + '\n'
                }
            }
         })
         return msg
      },
      upgradegetaccount() {
        state.formInline = {
          userName: state.searchusername,
          page: 1,
          pageSize: 10,
        };
        state.getList();
      },
      handleSearch() {
        state.getList();
    
        // })
      },
      editroleas(rows) {
    
        state.accouttitle = _t('account.compileusers');
        state.form = {
          name: rows.username,
          passwords: rows.password,
          rolesname: Number(rows.role_id),
          buildname: '',
          robotnames: rows.robot_sn.length>0?rows.robot_sn.split(","):'',
          fromdesc: rows.remark,
          surname: rows.nick_name,
        };
        // state.buildflge = false;
        state.detatildata.id = rows.id;
        state.rolenamedisabled = true;
        // buildingRobotsAll({
        //   limit: false,
        //   buildings: rows.building_ids,
        // }).then((res) => {
          
        //   state.robotlists = res.data;
        // });
        state.dialogVisible = true;
      },
      handleCurrentChange(page) {
        state.formInline.page = page;
        state.getList();
      },
      handleSizeChange(val) {
        state.formInline.pageSize = val;
        state.getList();
      },
      roleschanges(val) {
       
      },
      addroles() {
        state.accouttitle = _t('account.adduser');
        state.rolenamedisabled = false;
        state.form.robotnames = [];
        // state.robotlists = [];
        state.robotflge = true;
        state.buildflge = true;
        state.form = {
          name: "",
          passwords: "",
          rolesname: "",
          // buildname: [],
          robotnames: [],
          fromdesc: "",
          surname: "",
        };
        state.dialogVisible = true;
      },
      cancelmsg() {
        state.dialogVisible = false;
        state.rolenamedisabled = true;
        state.form = {
          name: "",
          passwords: "",
          rolesname: "",
          // buildname: [],
          robotnames: [],
          fromdesc: "",
          surname: "",
        };
        // state.rolenamedisabled = false;
        // state.valueroles = [];
        // state.fromdesc = "";
        // state.rolesname = "";
      },
      delroles() {
        // deleteeroles
        // console.log(state.detatildata);
        if (state.detatildata.types == 1) {
            // 重置密码
           replacementpswd({
            id: state.detatildata.id
           }).then(res=>{
         
            state.deletemapflage = false;
            // 关闭二次弹框后 在打开成功二次框
            state.successfalge = true
           })
        } else if (state.detatildata.types== 2) {
            // 删除用户
         delaccuser({
          id: state.detatildata.id,
          }).then((res) => {
         
          state.deletemapflage = false;
          state.getList();
        });
        }
      },
      cancelvisibles() {
        state.deletemapflage = false;
      },
      deleteroleas(row, type, msgs) {
     
        state.detatildata = row;
        if (type == 2) {
          state.detatildata["title"] = _t('account.deleteusers');
          state.detatildata["meassage"] = _t('account.Unabletologinafterdeleting');
        } else if (type == 1) {
          state.detatildata["title"] = _t('account.resetpasswords');
          state.detatildata["meassage"] = _t('account.alreadyexistsConfirmpasswords');
        }
        state.detatildata["types"] = type;
        state.deletemapflage = true;
      },
      trimbtn() {
        if (state.rolenamedisabled) {
          // true是编辑 false 是新增
          let params = {
            role_id: String(state.form.rolesname),
            nickname: state.form.surname,
            password: state.form.passwords,
            remark: state.form.fromdesc,
            robot_sn: state.form.robotnames.length>0?state.form.robotnames.join():'',
            username: state.form.name,
            building_id: "",
          };
          upgradeaccuser(params).then((res) => {
            state.ChangeAuthorityflg = true
            state.cancelmsg();
            state.getList();
          });
        } else {
          let formflge = true
           unref(userFormRef).validate((valid) => {
            
            if (valid) {
            } else {
              formflge = false
            }
          })
          if (!formflge) return
          let params = {
            role_id: String(state.form.rolesname),
            nickname: state.form.surname,
            password: state.form.passwords,
            remark: state.form.fromdesc,
            robot_sn: state.form.robotnames.length>0?state.form.robotnames.join():'',
            username: state.form.name,
            building_id: '',
          };
      
          // 增加 账号
          addaccuser(params).then((res) => {
            if (res.code == 200) {
              state.cancelmsg();
              state.getList();
            } else if(res.code == 40005) {
              ElMessage.error({
                center:'center',
                message:_t('account.alreadyExists')
              })
            }
          });
        }
      },
      // 时间转化
      getlogintimes(val) {
        if (val && val > 0) {
          return moment(val * 1000).format(momentStamp('dateTime'));
        } else {
          return "";
        }
      },
      // 获取 楼层下是否有机器人
      getsnlength(val) {
        let rowlist = [];
        val ? (rowlist = val.split(",")) : "";
        // console.log(rowlist);
        if (rowlist.length > 0) {
          return rowlist.length + _t('account.platform');
        } else {
          return _t('account.noBindingRobot');
        }
      },
      // 获取 角色列表
      getroleslist() {
        getroles({
          pageSize: 1,
          page: 1,
          limit: false,
        }).then((res) => {
          
          state.rolelist = res.data.list;
        });
      },
      // 获取楼宇参数
      getbuilds() {
        buildingListRequest({
          limit: false,
        }).then((res) => {
         
          state.buildlist = res.data.list;
          // 获取成功时候也要调用店铺接口拿到店铺数据
          shopQuery({
          limit: false,
        }).then(shopres=>{
        
            state.buildlist=state.buildlist.concat(shopres.data)
          })
        }).catch(err=>{
          // 获取失败也要调用拿到店铺数据
          shopQuery({
          limit: false,
        }).then(shopres=>{
            state.buildlist=state.buildlist.concat(shopres.data)
          })
        })
      },
      getbuildingRobotsAll() {
         buildingRobotsAll().then(res=>{
          state.robotlists = res.data
          console.log(state.robotlists,'查询所有机器人')
         })
      }
    });
    onMounted(() => {
      state.getroleslist();
      // state.getbuilds();
      state.getbuildingRobotsAll()
      state.handleSearch();
    });
    return {
      ...toRefs(state),
      searchForm,
      userFormRef,
      moment,
    };
  },
};
</script>
<style lang="scss">
// 弹出框

.el-popover.popperOptions{
  min-width: 50px !important;
  text-align: center;
}

.rolesclass {
  .select-box {
    display: flex;
    justify-content: center;
    position: relative;
    .tiptext {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .el-form-item--medium .el-form-item__label{
    font-size: 13px;
  }

}
.disinfectList {
  .Headerrowclass{
    // color: #000000;
  }
  .upgradeclass {
    width: 46px;
    height: 34px;
    line-height: 36px;
    box-sizing: content-box;
  }
  .el-range-editor--medium .el-range-separator {
    width: 25px;
  }
  .el-input-group__append {
    background: #1890ff;
    cursor: pointer;
    padding: 0;
    width: 46px;
    text-align: center;
  }
  .el-form-item {
    white-space: nowrap !important;
  }
  .el-form-item__label {
    width: 35% !important;
    display: inline-block;
  }
  .el-form-item__content {
    width: 80% !important;
    display: inline-block;
    .el-select,
    .el-cascader {
      width: 88% !important;
    }
  }
  .el-table .cell{
    word-break: normal;
    word-wrap: break-word !important;
  }
  .el-table__row {
    // cursor: pointer;
    .el-table_1_column_1,.el-table_1_column_7 {
      cursor: pointer;
    }
  }
  .start_row td {
    background: #e7f7ff;
  }
  .demo-date-picker {
    display: flex;
    width: 100%;
    padding: 0;
    flex-wrap: wrap;
  }
  .demo-date-picker .block {
    padding: 30px 0;
    text-align: center;
    border-right: solid 1px var(--el-border-color);
    flex: 1;
  }
  .demo-date-picker .block:last-child {
    border-right: none;
  }
  .demo-date-picker .demonstration {
    display: block;
    color: var(--el-text-color-secondary);
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss" scoped>
.disinfectList {
  position: relative;
  h3 {
    margin: 0 0 16px;
  }
  .inputStyle {
    width: 300px;
  }
  .addroles {
    position: absolute;
    left: 10px;
    top: 8px;
  }
  .btnadd {
    position: relative;
    min-width: 110px;
    background: #1890ff;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    padding: 0 20px 0 30px;
    margin-left: 20px;
    cursor: pointer;
    height: 32px;
    line-height: 32px;
  }
  .rolestop {
    display: flex;
    height: 40px;
    line-height: 40px;
    justify-content: space-between;
    align-items: center;
    .acclist {
      width: 72%;
    }
  }
  .robotItem {
    display: inline-block;
    position: relative;
    vertical-align: top;
    height: 230px;
    width: 90%;
    padding: 20px 20px 20px 130px !important;
    margin: 0 20px 30px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 10px;
    font-size: 14px !important;
    cursor: pointer;

    .robotImg {
      position: absolute;
      height: 160px;
      top: 30px;
      left: 40px;
    }
    p {
      img {
        width: 24px;
        margin: -4px 4px 0 0;
      }
      span {
        display: inline-block;
        vertical-align: top;
      }
    }
  }
  .robotTitle {
    font-size: 18px;
    font-weight: bold;
  }
  .searchBtn {
    margin-left: 200px;
    .openText {
      margin-left: 24px;
      // color: #409eff;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .circular {
    position: relative;
    margin: 2px 6px;
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: #000;
  }
}
.field {
  margin: 0 20px;
  line-height: 30px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

.field-text {
  margin: 0 10px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}
.fieldremark{
  margin: 0 20px;
  line-height: 30px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  display: flex;
  .field-text{
    word-break: normal;
    white-space: pre-wrap;
    word-wrap: break-word;
    max-width: 280px;
  }
}
.special {
  display: flex;
}
.btndiv {
  margin: 44px 0 0 0;
  display: flex;
  justify-content: right;
  button {
    padding: 0 12px;
    height: 32px;
  }
  .btnconfirm {
    background: #1890ff;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
  .btncancel {
    cursor: pointer;
    background: #ffffff;
    margin-right: 16px;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }
}
.dialog-footer {
    text-align: right;
    margin-top: 30px;
}
.text-box {
    padding: 20px 20px 10px;
    position: relative;
    top: -20px;
    left: -20px;
    display: flex;
    align-items: center;
    height: 22px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8500);
    line-height: 22px;
}

.title-text {
    margin-left: 10px;
}
</style>
